import * as THREE from 'three';

let rendererInstance = null;

export function getRenderer() {
    if (!rendererInstance) {
        rendererInstance = new THREE.WebGLRenderer();
    }
    return rendererInstance;
}